import { API_URL } from '../config/environment';

export const API_CONFIG = {
  BASE_URL: API_URL,
  TIMEOUT: 60000,
};

export const PROMPT_ENHANCER_CONFIG = {
  BASE_URL:
    process.env.REACT_APP_PROMPT_ENHANCER_URL || 'https://enhance.genanything.ai',
};

export const POLLING = {
  VIDEO_STATUS: 3000, // Poll every 3 seconds
  MAX_RETRIES: 160, // 160 retries * 3 seconds = 8 minutes max
};

export const API_ENDPOINTS = {
  AUTH: {
    VALIDATE_EMAIL: '/api/auth/validate-email',
  },
  USER: {
    GET: '/api/user',
    UPDATE: '/api/user/credits',
    SIGNUP: '/api/user/signup',
  },
  VIDEOS: {
    LIST: '/videos',
    DELETE: '/videos',
    FAVORITE: '/videos/favorite',
  },
  GENERATE: {
    CREATE: '/generate',
    STATUS: '/generate/status',
    VIDEO: '/api/generate/video',
  },
  EXPORT: '/export',
  MODELS: '/models',
  TEMPLATES: '/templates',
  PAYMENT: {
    CREATE_CHECKOUT_SESSION: '/create-checkout-session',
  },
  UPLOAD: {
    IMAGE: '/api/upload/image',
  },
  PROMPT_ENHANCER: {
    ENHANCE_AND_GENERATE: '/api/enhance-from-supabase',
  },
  CREDITS: {
    BALANCE: '/api/user/credits/balance',
    HISTORY: '/api/user/credits/history',
    RETARGETING_BONUS: '/api/credits/retargeting-bonus',
  },
  STRIPE: {
    CREDIT_PACKS: '/api/stripe/credit-packs',
    CREATE_CREDIT_CHECKOUT: '/api/stripe/create-credit-checkout',
    CREDIT_CHECKOUT: '/api/stripe/credit-checkout',
    SUBSCRIPTION_PLANS: '/api/stripe/plans',
    SAVED_CARD: '/api/stripe/saved-card',
    QUICK_BUY_CREDIT_PACK: '/api/stripe/quick-buy-credit-pack',
    WALLET_PURCHASE: '/api/stripe/wallet-purchase',
  },
};

// Credit costs for different operations.
//
// These are typed fallbacks. The server is authoritative — paid users
// receive `credit_costs: { video_5s, video_10s }` in their bootstrap
// payload (GET /api/user) and the frontend should prefer those values
// via getCostForDuration() in services/credits.ts. These constants are
// retained indefinitely (per docs/duration-toggle-plan.md Decision #2)
// so that an old cached SPA bundle without the server field still
// renders a sensible default.
export const CREDIT_COSTS = {
  VIDEO_GENERATION: 100,      // 5s, default
  VIDEO_GENERATION_10S: 200,  // 10s, homepage opt-in (paid users)
  IMAGE_GENERATION: 1,
  IMAGE_EDIT: 2,
  UPLOAD: 0,
  ENHANCEMENT: 0,
};

// OAuth return path storage key (used by AuthContext and AuthCallbackPage)
export const OAUTH_RETURN_KEY = 'oauth_return_path';

